// The federation's two public addresses. The Go twin is
// internal/mail/templates/_layout.html, which prints both in every mail's
// footer; change them together.

// Anything the system itself is in the way of: logging in, a password link
// that never arrived, an error screen, a bug.
export const TECH_CONTACT = "it@cmtfederation.cz";

// Everything else: membership, the team's application, competitions, and the
// data a leader may not change themselves („kontaktujte ČNSMS").
export const GENERAL_CONTACT = "info@cmtfederation.cz";
